import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueMask from 'v-mask'
import i18n from '@/i18n'
import colors from 'vuetify/lib/util/colors'
import '@/sass/overrides.sass'
import '@/sass/idc.sass'

Vue.use(Vuetify)
Vue.use(VueMask)

const theme = {
  primary: '#ED1E79',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
  submit: '#8C9EFF',
  download: '#ff948c',
  header: '#1F7087',
  header_color: '#1F7087',
  grey: colors.grey.base,
  grey_light: colors.grey.lighten1,
  dark_red: '#a52a2a',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
